'use strict';

angular.module('partnerlogin', ['ui.bootstrap', 'ngStorage']).config(['$httpProvider', '$compileProvider', function ($httpProvider, $compileProvider) {
  $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|data):/);
  $httpProvider.interceptors.push('tokenInjector');
}]).run(['$rootScope', function ($rootScope) {
  $rootScope.alerts = [];
}]).service('tokenInjector', ['$rootScope', '$sessionStorage', '$window', function ($rootScope, $sessionStorage, $window) {

  function addHeader(config) {
    var apiUrl = $window.MYSTRENGTH.API_URL || 'https://api.mystrength.com';
    var partnerUrl = apiUrl + '/partner/v1';
    config.url = config.url.replace('/apiproxy', apiUrl);
    config.url = config.url.replace('/partnerproxy', partnerUrl);
    if ($sessionStorage.token) {
      config.headers['x-session-token'] = $sessionStorage.token;
    }
    return config;
  }

  function setToken(t) {
    $sessionStorage.token = t;
  }

  function getToken() {
    return $sessionStorage.token;
  }

  function getTokenTimeout() {
    if (!$sessionStorage.token) {
      return new Date(0);
    }
    try {
      return new Date(JSON.parse(atob($sessionStorage.token.split('.')[1])).exp * 1000);
    } catch (e) {
      return new Date(0);
    }
  }

  function isLoggedIn() {
    return getTokenTimeout() > new Date();
  }

  function responseError(err) {
    $rootScope.alerts.push({
      message: err.data.message || err.statusText
    });
    return err;
  }
  return {
    request: addHeader,
    responseError: responseError,
    setToken: setToken,
    getToken: getToken,
    isLoggedIn: isLoggedIn,
    getTokenTimeout: getTokenTimeout

  };
}]).controller('LoginCtrl', ['$scope', '$http', 'tokenInjector', function ($scope, $http, tokenInjector) {
  $scope.creds = {};
  $scope.isChrome = !!window.chrome;

  $scope.isLoggedIn = tokenInjector.isLoggedIn;
  $scope.showDoc = false;

  if (tokenInjector.getToken()) {
    $scope.token = tokenInjector.getToken();
    $scope.timeout = tokenInjector.getTokenTimeout();
  }

  $scope.logout = function () {
    tokenInjector.setToken(null);
    $scope.token = null;
  };

  $scope.login = function () {
    $http.post('/apiproxy/partner/v1/login', $scope.creds).then(function (dat) {
      $scope.token = dat.data.token;
      tokenInjector.setToken(dat.data.token);
      $scope.timeout = tokenInjector.getTokenTimeout();
    });
  };

  $scope.toggleDoc = function () {
    $scope.showDoc = !$scope.showDoc;
  };

  $scope.endpoints = [{
    name: 'User Profiles',
    endpoint: 'users/profiles?accessCodeType=CONSUMER',
    description: 'Gets standard profile information about the user, such as first name, email, age and gender.'
  }, {
    name: 'User Interests',
    endpoint: 'users/interests?accessCodeType=CONSUMER',
    description: 'Gets information about the user\'s interests, such as lifestyle, spirituality and health topics.'
  }, {
    name: 'User Sign-up Responses',
    endpoint: 'users/signupresponses?accessCodeType=CONSUMER',
    description: 'Gets the user\'s sign-up responses, such as member id or clinician.  NOTE: May contain e-PHI.'
  }, {
    name: 'User Activities Completion',
    endpoint: 'activities/responses?accessCodeType=CONSUMER',
    description: 'Gets information about the user\'s completed activities on the site.'
  }, {
    name: 'Wellness Assessments',
    endpoint: 'assessments/responses?accessCodeType=CONSUMER',
    description: 'Gets information about the user\'s interests, such as lifestyle, spirituality and health topics.'
  }, {
    name: 'Mood Tracker',
    endpoint: 'moods/responses?accessCodeType=CONSUMER',
    description: 'The entries users have made in their mood tracker.'
  }];
}]).directive('msDataDownload', ['$http', '$rootScope', function ($http, $rootScope) {
  return {
    restrict: 'AE',
    link: postLink
  };

  function postLink(scope, ele, attrs) {
    scope.text = 'Prepare';

    function download() {
      ele.off('click');
      scope.text = 'Preparing...';
      $http.get('/partnerproxy' + attrs.url, {
        headers: {
          accept: 'text/csv'
        }
      }).then(function (dat) {
        ele.attr('href', window.URL.createObjectURL(new Blob([dat.data])));
        scope.text = 'Download';
      }, function (err) {
        $rootScope.alerts.push({
          message: err.data.message || err.statusText
        });
        // reattach handler for retry
        ele.on('click', download);
      });
    }
    ele.on('click', download);
  }
}]);